import {
  // private
  // @ts-expect-error
  PRIVATE_API_DO_NOT_TOUCH_NO_SEMVER_SUPPORT,
} from 'effector'

PRIVATE_API_DO_NOT_TOUCH_NO_SEMVER_SUPPORT.setDebugTraces(true)
